import React from 'react';
import PropTypes from 'prop-types';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { CommunityIcon } from 'global/components/PerformIcons';

export default function PerformRealmCommunity({
    realm = {},
    currentRealm = 0,
    ...props }) {
  const community = realm;

  return (
    <ListItemButton style={{ marginLeft: 64 }}>
      <ListItemIcon>
        <CommunityIcon />
      </ListItemIcon>
      <ListItemText primary={community.name} />
    </ListItemButton>
  );
}

PerformRealmCommunity.propTypes = {
  realm: PropTypes.object,
  currentRealm: PropTypes.number,
};
